import { useContext } from 'react'
import { CutterContext } from '../../contexts/CutterContext'
import { InterfaceEvent } from '../../../interfaces/InterfaceEvent'
import { PositionRange } from '../../../types'
import { useValidateVisibleRange } from '../../hooks/useValidateVisibleRange'
import { useAbsolutePixelSize } from '../../hooks/useAbsolutePixelSize'

interface InitialState {
  clientX: number
  visibleRange: PositionRange
}

export function useMoveScroll(containerWidth: number) {
  const { setVisibleRange } = useContext(CutterContext)
  const validateVisibleRange = useValidateVisibleRange()
  const pixelSize = useAbsolutePixelSize(containerWidth)

  return ({ clientX }: InterfaceEvent, initialState: InitialState) => {
    const delta = (clientX - initialState.clientX) * pixelSize

    setVisibleRange(validateVisibleRange([initialState.visibleRange[0] + delta, initialState.visibleRange[1] + delta]))
  }
}
